import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { BFF_BASE_URL } from '@/core/api/bff-base-url';
import { AUTH_PATHS } from '../api/auth.api';
import { AuthStore } from '../state/auth.store';

const PUBLIC_PATHS = [
  AUTH_PATHS.login,
  AUTH_PATHS.refresh,
  AUTH_PATHS.resetPassword,
  AUTH_PATHS.confirmPassword,
];
const COOKIE_PATHS = [AUTH_PATHS.login, AUTH_PATHS.refresh, AUTH_PATHS.logout];

export function isBffRequest(url: string, baseUrl: string): boolean {
  if (!baseUrl) {
    return url.startsWith('/') && !url.startsWith('//');
  }
  return url === baseUrl || url.startsWith(`${baseUrl}/`);
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const baseUrl = inject(BFF_BASE_URL);
  if (!isBffRequest(req.url, baseUrl)) {
    return next(req);
  }

  const path = req.url.slice(baseUrl.length).split('?')[0];
  const token = inject(AuthStore).accessToken();

  let headers = req.headers;
  if (token && !PUBLIC_PATHS.includes(path as (typeof PUBLIC_PATHS)[number])) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  const withCredentials = COOKIE_PATHS.includes(path as (typeof COOKIE_PATHS)[number]);

  return next(req.clone({ headers, withCredentials }));
};
